import { CALL_API } from 'assets/js/apiMiddleware'
import { actionTypes } from 'assets/js/actionTypes'
import { persistAssistances, persistReport } from 'assets/js/assitances'
import { isArray } from 'lodash'
import { AssistStatus } from 'assets/enumerators'
export const startCustomerServiceActions = actionTypes('INICIAR_ATENDIMENTO')
export const stopCustomerServiceActions = actionTypes('FINALIZAR_ATENDIMENTO')
export const cancelCustomerServiceActions = actionTypes('CANCELAR_ATENDIMENTO')
export const loadCurrentCustomerServiceActions = actionTypes('CARREGAR_ATENDIMENTO')
export const selectPatientsActions = 'SELECIONAR_PACIENTE_ATENDIMENTO'
export const generateAssistancePLRReportActions = 'GENERATE_ASSISTANCE_PLR_REPORT'

export default function (state = { loading: false, loadingPatient: false }, action = []) {
  switch (action.type) {
    case stopCustomerServiceActions.BEGIN:
    case startCustomerServiceActions.BEGIN:
    case loadCurrentCustomerServiceActions.BEGIN:
    case cancelCustomerServiceActions.BEGIN:
      return { ...state, loading: true }
    case loadCurrentCustomerServiceActions.SUCCESS:
    case startCustomerServiceActions.SUCCESS:
      const data = isArray(action.response) ? action.response : [action.response]
      return {
        ...state,
        loading: false,
        customerService: [...data]
      }
    case stopCustomerServiceActions.SUCCESS:
    case cancelCustomerServiceActions.SUCCESS:
      return {
        ...state,
        loading: false,
        customerService: [{ ...state.customerService[0], status: AssistStatus.CONCLUDED }]
      }
    case loadCurrentCustomerServiceActions.ERROR:
      return {
        ...state,
        loading: false
      }
    case selectPatientsActions:
      return {
        ...state,
        selectingPatient: action.response,
      }
    case generateAssistancePLRReportActions:
      return {
        ...state,
        lastGeneratedReport: [{
          ...action.response.customerService,
          ...action.response.plr
        }]
      }
    default:
      return {
        ...state
      }
  }
}

export const startCustomerService = ({ patientId, accountId, clinicId }) => {
  return dispatch => {
    return dispatch({
      [CALL_API]: {
        type: startCustomerServiceActions,
        endpoint: '/assists/merge',
        method: 'post',
        data: { patientId, accountId, clinicId, status: AssistStatus.IN_PROGRESS }
      }
    })
  }
}

export const restartCustomerService = ({ id, patientId, accountId, clinicId }) => {
  return dispatch => {
    return dispatch({
      [CALL_API]: {
        type: startCustomerServiceActions,
        endpoint: '/assists/merge',
        method: 'post',
        data: { id, patientId, accountId, clinicId, status: AssistStatus.IN_PROGRESS }
      }
    })
  }
}

export const stopCustomerService = ({ id, patientId, accountId, clinicId, createdAt, updatedAt }) => {
  return dispatch => {
    sessionStorage.removeItem('testAbpm');
    sessionStorage.removeItem('testAbpmFlux');
    sessionStorage.removeItem('testHbpm');
    sessionStorage.removeItem('testHbpmFlux');
    return dispatch({
      [CALL_API]: {
        type: stopCustomerServiceActions,
        endpoint: '/assists/merge',
        method: 'post',
        data: {
          status: AssistStatus.CONCLUDED,
          id,
          patientId,
          accountId,
          clinicId,
          createdAt,
          updatedAt
        }
      }
    })
  }
}
export const cancelCustomerService = ({ id, patientId, accountId, clinicId }) => {
  return dispatch => {
    sessionStorage.removeItem('testAbpm');
    sessionStorage.removeItem('testAbpmFlux');
    sessionStorage.removeItem('testHbpm');
    sessionStorage.removeItem('testHbpmFlux');
    return dispatch({
      [CALL_API]: {
        type: stopCustomerServiceActions,
        endpoint: '/assists/merge',
        method: 'post',
        data: {
          status: AssistStatus.CANCELED,
          id,
          patientId,
          accountId,
          clinicId
        }
      }
    })
  }
}

export const loadCustomerService = ({ accountId, clinicId }) => {
  return dispatch => {
    const currentUserId = localStorage.getItem('id');
    return dispatch({
      [CALL_API]: {
        type: loadCurrentCustomerServiceActions,
        endpoint: `/assists?accountId=${currentUserId}`,
        data: {
          status: AssistStatus.IN_PROGRESS,
          accountId,
          clinicId
        },
        retries: 5
      }
    }).then(data => {
      if (data && data.type && data.type !== loadCurrentCustomerServiceActions.ERROR) {
        persistAssistances(data.response)
      }
    })
  }
}

export const selectPatient = selecionar => {
  return dispatch => {
    dispatch({ type: selectPatientsActions, response: selecionar })
  }
}

export const gerenateAssistancePLRReport = (reportData) => {
  return dispatch => {
    persistReport(reportData)
    return dispatch({ type: generateAssistancePLRReportActions, response: reportData })
  }
}